import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { PostDataWithToken } from '../../constants/ApiHelper'
import { useNavigate } from 'react-router'
import Loader from '../../common/Loader'

import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchMmvData } from '../../store/actions/userActions'
import Layout from '../../common/Layout'
import { toast } from 'react-toastify'

const AddMM = () => {
  const dispatch = useDispatch()
  // const loginUrl = 'https://api.insurefast.in/api/v1/'
   const loginUrl = 'https://uatmasterapi.flaskitsolutions.com'
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ mode: 'onBlur' })
  const navigate = useNavigate()
  const [showPass, setShowPass] = useState(false)
  const [loading, setLoading] = useState(false)
  const cookie = useCookies()
  const [cookies, setCookie, removeCookie] = useCookies([
    'userName',
    'token',
    'role'
  ])
  useEffect(() => {
    dispatchMmvData('apiUrl', loginUrl)
  })

  const handleCreate = data => {
    setLoading(true)
    PostDataWithToken('/login-panel/create-login', data)
      .then(res => {
        if (res && res.success) {
          const { token, username, role } = res.data
          setCookie('token', token, { path: '/' })
          setCookie('username', username, { path: '/' })
          setCookie(role, role, { path: '/' })
          toast.success(res?.message)
        } else {
          console.error('Login failed:', res)
          toast.error(res?.message)
        }
      })
      .catch(error => {
        console.error('Login error:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
return (
  <Layout>
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f6f9",
        padding: "20px"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          background: "#fff",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
        }}
      >
        {/* Header */}
        <h3
          style={{
            textAlign: "center",
            marginBottom: "25px",
            fontWeight: "600",
            color: "#333",
            fontSize:'20px'
          }}
        >
          Create Mapping Manager Account
        </h3>

        <form onSubmit={handleSubmit(handleCreate)}>

          {/* Full Name */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "500", fontSize: "14px" }}>
              Full Name
            </label>
            <input
              type="text"
              placeholder="Enter Full Name"
              {...register("username", {
                required: "Username is required"
              })}
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                outline: "none"
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors.username?.message}
            </p>
          </div>

          {/* Email */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "500", fontSize: "14px" }}>
              Email
            </label>
            <input
              type="email"
              placeholder="Enter Email Id"
              {...register("email", {
                required: "Email is required"
              })}
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                outline: "none"
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors.email?.message}
            </p>
          </div>

          {/* Mobile */}
          <div style={{ marginBottom: "18px" }}>
            <label style={{ fontWeight: "500", fontSize: "14px" }}>
              Mobile
            </label>
            <input
              type="number"
              placeholder="Enter Mobile Number"
              {...register("mobileNo", {
                required: "Mobile No is required"
              })}
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                outline: "none"
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors.mobileNo?.message}
            </p>
          </div>

          {/* Role */}
          <div style={{ marginBottom: "25px" }}>
            <label style={{ fontWeight: "500", fontSize: "14px" }}>
              Add Role
            </label>

            <select
              {...register("role", {
                required: "Role is required"
              })}
              style={{
                width: "100%",
                marginTop: "6px",
                padding: "10px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                outline: "none",
                background: "#fff"
              }}
            >
              <option value="">Select Role</option>
              <option value="mappingManager">Mapping Manager</option>
            </select>

            <p style={{ color: "red", fontSize: "12px" }}>
              {errors.role?.message}
            </p>
          </div>

          {/* Button */}
          <button
            type="submit"
            className='btn btn-sec'
            style={{
              width: "100%",
              padding: "12px",
              // background: loading ? "#999" : "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              cursor: "pointer"
            }}
            disabled={loading}
          >
            {loading ? <Loader /> : "Create Account"}
          </button>
        </form>
      </div>
    </div>
  </Layout>
);
}

export default AddMM